'use client'

import Link from 'next/link'
import { toast } from 'sonner'
import LinkIcon from '@/components/core/icons/LinkIcon'
import LinkedInIcon from '@/components/core/icons/LinkedInIcon'
import MailIcon from '@/components/core/icons/MailIcon'
import XIcon from '@/components/core/icons/XIcon'
import { useEffect, useState, type JSX } from 'react'

export default function CustomerStoryShare() {
  const [shareButtons, setShareButtons] = useState<{ icon: JSX.Element; alt: string; url: string }[]>([])

  const handleShare = () => {
    navigator.clipboard.writeText(window.location.href)
    toast.success('Copied link to clipboard')
  }

  useEffect(() => {
    setShareButtons([
      {
        icon: <LinkedInIcon />,
        alt: 'Share on LinkedIn',
        url: `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`,
      },
      {
        icon: <XIcon />,
        alt: 'Share on X',
        url: `https://x.com/intent/post?url=${window.location.href}`,
      },
      {
        icon: <MailIcon />,
        alt: 'Share via e-Mail',
        url: `mailto:?subject=&body=${window.location.href}`,
      },
      {
        icon: <LinkIcon />,
        alt: 'Copy link to clipboard',
        url: '',
      },
    ])
  }, [])

  return (
    <div className="col-span-full pt-6 pb-10 md:pt-10 md:pb-16">
      <ul className="flex flex-row gap-2 items-center">
        <li className="bg-red-900 backdrop-blur-[16px] text-red font-mono text-[9px] font-semibold leading-xxl tracking-xl uppercase px-3 py-1.5 rounded">
          Share
        </li>
        {shareButtons.map((button, index) => (
          <li
            key={'share-button-' + index}
            className="hover:text-red-500 text-grey-600 h-6 overflow-hidden transition-all ease-in-out duration-100"
          >
            {button.url ? (
              <Link href={button.url} target="_blank" title={button.alt}>
                {button.icon}
              </Link>
            ) : (
              <button onClick={handleShare} title={button.alt}>
                {button.icon}
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
